@if (reportReady) {
    <powerbi-report [embedConfig]='reportConfig' [cssClassName]="powerBiClass" [phasedEmbedding]='powerBIPhasedEmbedding' [eventHandlers]='powerBiEventHandlers'></powerbi-report>
}
